import React, {createRef, useEffect} from "react";
import {IModal} from "components/UI/Modal/Modal";

interface IModalWrapperProps extends IModal {
    children: React.ReactNode;
}

const ModalWrapper: React.FC<IModalWrapperProps> = (
    {
        children,
        isOpen,
        setIsOpen,
    }
) => {
    const modalRef = createRef<HTMLDivElement>();

    const keyDownHandler = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.code === "Escape") {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        modalRef.current?.focus();
    }, []);

    return (
        <div ref={modalRef} tabIndex={0} onKeyDown={keyDownHandler} onClick={() => {
            setIsOpen(false)
        }} className={`modal ${isOpen ? "modal--open" : ""}`}>
            {children}
        </div>
    );
};

export default ModalWrapper;